import { createSelector } from 'reselect'

const segmentSelector = ({ segment }) => segment

export const identifyOptionsSelector = createSelector(
  segmentSelector,
  ({ identify_options: identifyOptions }) => identifyOptions
)

export const anonymousIdSelector = createSelector(
  segmentSelector,
  ({ anonymous_id: anonymousId }) => anonymousId
)
